<template>
   <div>
      <v-container class="payment-method-container">
        <v-row no-gutters>
        <v-col  :cols="$vuetify.breakpoint.xs ? 12 : 6" class="mt-3">
        <v-row class="pa-0 ma-0" v-if="payment_type && payment_type.toLowerCase() === 'eftpos'">
          <v-col class="pa-0 ma-0">
            <v-row no-gutters class="mt-2">
            <v-col cols="4" :class="{'hb-font-caption-medium' : $vuetify.breakpoint.xs , 'hb-font-body-medium' : !$vuetify.breakpoint.xs}" :cols="$vuetify.breakpoint.xs ? 7: 6" >
              <span :class="{'text-error' : errors.first('amountTendered') }">Transaction Amount : </span>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xs ? 5: 6">
            <hb-text-field
              box
              key="amountTendered"
              class="cash-input-filed"
              hide-details
              :value="getPrecisiedVal"
              v-validate="`required|min_value:${paymentData.totalNewPaymentPaying}`"
              data-vv-name="amountTendered"
              data-vv-as="Cash Amount Tendered"
              :error-messages="errors.collect('amountTendered')"
              prepend-inner-icon="mdi-currency-usd"
              id="amountTendered"
              name="amountTendered"
              @input="handleAmountTendered('amountTendered', $event)"
              @blur="$validator.validate('amountTendered')"
              condensed
            >
            <template v-slot:prepend-inner>
                 <div>
                  $
                 </div>
          </template>
            </hb-text-field>
            </v-col>
          </v-row>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0" >
          <v-col class="pa-0 ma-0">
            <v-text-field
              key="transaction_id"
              :class="{'custom-field-error' : errors.first('transaction_id')}"
              hide-details
              :value="payment_method.transaction_id"
              v-validate="'max:45'"
              data-vv-name="transaction_id"
              data-vv-as="Transaction Id"
              :error-messages="errors.collect('transaction_id')"
              label="Transaction ID"
              id="transaction_id"
              name="transaction_id"
              @input="handleInputUpdate('payment', 'transaction_id', $event)"
              >
            </v-text-field>
            <small class="small-label" >Mentioned as TID in the Receipt</small>
          </v-col>
        </v-row>
        <v-row class="pa-0 mx-0 mt-3" >
          <v-col class="pa-0 ma-0">
            <v-select
              key="card_type"
              :items="['Visa','Mastercard','JCB','AMEX']"
              hide-details
              :value="payment_method.card_type"
              :class="{'custom-field-error' : errors.first('card_type')}"
              data-vv-name="card_type"
              data-vv-as="Card Type"
              :error-messages="errors.collect('card_type')"
              label="Card Type"
              id="card_type"
              name="card_type"
              @input="handleInputUpdate('payment_method', 'card_type', $event)"
              >
            </v-select>
          </v-col>
        </v-row>
  
        <v-row class="pa-0 ma-0">
          <v-col class="pa-0 mb-3 pt-3 mt-3">
            <v-textarea
              :class="{'custom-field-error' : errors.first('notes')}"
              class="mt-3"
              hide-details
              :value="payment.notes"
              data-vv-name="notes"
              :error="errors.has('notes')"
              label="Notes"
              id="cash-notes"
              name="cash-notes"
              autocomplete="cc-cash-notes"
              @input="handleInputUpdate('payment', 'notes', $event)"
              backgroundColor=""
              rows="1"
              auto-grow
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>
      </v-row>
      </v-container>
    </div> 
  </template>
  
  
  <script type="text/babel">
  
      import PaymentMethodBase from './PaymentMethodBase.vue';
      import HbDatePicker from '../../assets/HummingbirdDatepicker';
      import VuetifyStatepicker from '../../includes/VuetifyStatepicker.vue';
      import { EventBus } from '../../../EventBus';
      import { mapGetters, mapMutations } from "vuex";
  
      export default {
          extends: PaymentMethodBase,
          data() {
              return {
              }
          },
          components:{
            HbDatePicker,
            VuetifyStatepicker
          },
          computed:{
            ...mapGetters({
              paymentConfig: 'paymentsStore/getPaymentSourceConfig',
              paymentData: 'paymentsStore/getPaymentInformation',
              payment_method: 'paymentsStore/getPaymentMethod',
              contact: 'paymentsStore/getContact',
              payment: 'paymentsStore/getPayment',
              getErrors: 'paymentsStore/getErrors'
          }),
            getPrecisiedVal() {
              return this.paymentData.amountTendered ? parseFloat(this.paymentData.amountTendered).toFixed(2) : this.paymentData.amountTendered;
            }
          },
          created(){
          },
          destroyed() {
          },
          props: ['payment_type'],
          methods:{
            ...mapMutations({
              setCheckErrors: 'paymentsStore/setCheckErrors',
              setPayment: 'paymentsStore/setPayment',
              setPaymentInformation: 'paymentsStore/setPaymentInformation',
              setPayment: 'paymentsStore/setPayment',
              setPaymentObject: 'paymentsStore/setPaymentObject',
              setPaymentMethod: 'paymentsStore/setPaymentMethod',
              setPaymentMethodObject: 'paymentsStore/setPaymentMethodObject',
            }),
  
            handleAmountTendered : _.debounce(async function(property_name, property_value) {
              property_value = Number(parseFloat(property_value).toFixed(2)) || 0;
              this.setPaymentInformation({property: property_name, propertyValue: property_value});
            }, 1000),
  
            handleUpdate(obj, property_name, property_value){
        if(obj === 'payment'){
          this.setPayment({property: property_name, propertyValue: property_value});
        }
        if(obj === 'payment_method'){
          this.setPaymentMethod({property: property_name, propertyValue: property_value});
        }
      },
        handleInputUpdate : _.debounce(async function(obj, property_name, property_value) {
          this.handleUpdate(obj, property_name, property_value);
        }, 200),
  
            validateFields(){
              return this.$validator.validateAll();
            }
          },
          watch:{
          }
  
  
      }
  </script>

   <style scoped> 
  .text-error {
    color: red !important;
  }
  
  .small-label {
    font-size: 11px; 
    color: grey;
  }
  
  .cash-input-filed {
    padding-top: 0px;
    max-width: 100px;
  }
  .hb-text-field-width-370{
    max-width: 100% !important;
  }
  .v-text-field{
    padding-top: 0px !important;
    margin-top: 0px !important;
  }
  .cash-input-filed  >>> fieldset legend{
    display: none !important;
}
  </style>
  